import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (params) {
    return store.dispatch('checkResponseApi', await Api().get('pos/branches', { params }))
  },

  async getSingle (id, params) {
    return store.dispatch('checkResponseApi', await Api().get(`pos/branches/${id}`, { params }))
  },

  async insert (params) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('pos/branches', params, options))
  },

  async update (id, params) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`pos/branches/${id}`, params, options))
  },

  async updateAssignProductIds (id, params) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`pos/branches/${id}/assign-products`, params, options))
  },

  async updateFavoriteProductIds (id, params) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`pos/branches/${id}/favorite-products`, params, options))
  },

  async delete (id) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().delete(`pos/branches/${id}`, null, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/PosBranchService.js